/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, hour: NonNullable<unknown> }} Monthly_Challenge_TimerInputs */

const en_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ends in ${i?.day}d ${i?.hour}h`)
};

const ar_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ينتهي خلال ${i?.day} يوم و${i?.hour} ساعة`)
};

const de_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Endet in ${i?.day} T. ${i?.hour} Std.`)
};

const es_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termina en ${i?.day}d ${i?.hour}h`)
};

const fr_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se termine dans ${i?.day} j ${i?.hour} h`)
};

const it_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termina tra ${i?.day}g ${i?.hour}o`)
};

const ja_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`終了まであと${i?.day}日${i?.hour}時間`)
};

const ko_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`종료까지 ${i?.day}일 ${i?.hour}시간`)
};

const pt_br_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termina em ${i?.day}d ${i?.hour}h`)
};

const ru_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Заканчивается через ${i?.day} д. ${i?.hour} ч.`)
};

const th_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สิ้นสุดในอีก ${i?.day} วัน ${i?.hour} ชม.`)
};

const tr_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} gün ${i?.hour} saat içinde bitiyor`)
};

const zh_cn_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`剩下 ${i?.day} 天 ${i?.hour} 小时`)
};

const zh_tw_monthly_challenge_timer = /** @type {(inputs: Monthly_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`剩下 ${i?.day} 天 ${i?.hour} 小時`)
};

/**
* | output |
* | --- |
* | "Ends in {day}d {hour}h" |
*
* @param {Monthly_Challenge_TimerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_challenge_timer = /** @type {((inputs: Monthly_Challenge_TimerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Challenge_TimerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_challenge_timer(inputs)
	if (locale === "ar") return ar_monthly_challenge_timer(inputs)
	if (locale === "de") return de_monthly_challenge_timer(inputs)
	if (locale === "es") return es_monthly_challenge_timer(inputs)
	if (locale === "fr") return fr_monthly_challenge_timer(inputs)
	if (locale === "it") return it_monthly_challenge_timer(inputs)
	if (locale === "ja") return ja_monthly_challenge_timer(inputs)
	if (locale === "ko") return ko_monthly_challenge_timer(inputs)
	if (locale === "pt_br") return pt_br_monthly_challenge_timer(inputs)
	if (locale === "ru") return ru_monthly_challenge_timer(inputs)
	if (locale === "th") return th_monthly_challenge_timer(inputs)
	if (locale === "tr") return tr_monthly_challenge_timer(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_challenge_timer(inputs)
	return zh_tw_monthly_challenge_timer(inputs)
});